"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _Record2;

var SubscriptionDefinition =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(SubscriptionDefinition, _Record);

  function SubscriptionDefinition(def) {
    (0, _classCallCheck2.default)(this, SubscriptionDefinition);

    if (def.translations && def.translations.length) {
      var codes = [];
      def.translations.forEach(function (translation) {
        codes.push(translation.languageCode);
      });
      def.languageCodes = new _immutable.Set(codes);
    }

    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SubscriptionDefinition).call(this, def));
  }

  return SubscriptionDefinition;
}((0, _immutable.Record)((_Record2 = {}, (0, _defineProperty2.default)(_Record2, _constants.ACTIVE, null), (0, _defineProperty2.default)(_Record2, _constants.DESCRIPTION, null), (0, _defineProperty2.default)(_Record2, "id", null), (0, _defineProperty2.default)(_Record2, _constants.NAME, null), (0, _defineProperty2.default)(_Record2, "portalId", null), (0, _defineProperty2.default)(_Record2, "internal", null), (0, _defineProperty2.default)(_Record2, "process", ''), (0, _defineProperty2.default)(_Record2, "operation", ''), (0, _defineProperty2.default)(_Record2, "position", 0), (0, _defineProperty2.default)(_Record2, "translations", []), (0, _defineProperty2.default)(_Record2, "languageCodes", (0, _immutable.Set)()), _Record2), _constants.SUBSCRIPTION_DEFINTION));

exports.default = SubscriptionDefinition;
module.exports = exports.default;